import ApiBase from './api-base'
import { isEarlyAccessFlagOn } from './product'

class Waitlist extends ApiBase {
  constructor () {
    super()
    this.url = `/v2.3/waitlist`
    this.params = {
      skips: ['wishlist', 'waitlist']
    }
  }

  async fetch ({
    sort = '',
    brandId = '',
    availability = '',
    pageNumber = 1,
    // 500 is to follow how brands is fetch
    // this is by legacy design although ideally we should paginate
    // temporary do not paginate as we would require to fetch all user's waitlisted items to mark as waitlisted on product page
    pageSize = 500
  } = {}) {
    const version = await isEarlyAccessFlagOn() ? '2.6' : '2.3'
    const { data } = await this.client.get(`/v${version}/my/waitlist/variants`, {
      params: {
        include: 'product',
        'page[number]': pageNumber,
        'page[size]': pageSize,
        ...(brandId ? { 'filter[brand]': brandId } : {}),
        ...(availability ? { 'filter[availability]': availability } : {})
      }
    })

    return data
  }

  async filters () {
    const { data } = await this.client.get('/v2.3/my/waitlist/filters')

    return data
  }

  async add (variantIds = '') {
    const url = `${this.url}/variants/${variantIds}`

    const { data } = await this.client.put(url, {}, {
      params: this.params
    })

    return data
  }

  async remove (variantIds = '') {
    const url = `${this.url}/variants/${variantIds}`

    const { data } = await this.client.delete(url, {
      params: this.params
    })

    return data
  }
}

export async function addToWaitlist (variantId, api = new Waitlist()) {
  const url = `/v2.5/waitlist/variants/${variantId}`
  return api.client.put(url)
}

export default Waitlist
